import React, { useEffect, useState, useContext } from "react";
import {
  MdTerrain,
  MdElectricCar,
  MdHeight,
  MdShield,
} from "react-icons/md";
import { ReactComponent as FullSizeSuvIcon } from "../../../../assets/icons/mheroicon.svg";
import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";
import "./Mhero1Extras.css";

const CARD_ICONS = [
  MdTerrain,
  MdElectricCar,
  MdHeight,
  FullSizeSuvIcon,
];

const Mhero1Extras = () => {
  const { currentLang } = useContext(LanguageContext);

  const [extras, setExtras] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadExtras = async () => {
      try {
        setLoading(true);
        const response = await getPageContent("mhero1", currentLang);
        setExtras(response.sections?.extras || null);
      } catch (err) {
        console.error("Failed to load MHERO1 extras", err);
      } finally {
        setLoading(false);
      }
    };

    loadExtras();
  }, [currentLang]);

  if (loading || !extras) return null;

  const cards = [1, 2, 3, 4]
    .map((n) => ({
      title: extras[`feature_${n}_title`],
      description: extras[`feature_${n}_description`],
    }))
    .filter((card) => card.title || card.description);

  return (
    <section className="mhero1extras">
      <div className="extras-container">
        <div className="extras-header">
          {extras.title ? (
            <h2 className="extras-title">{extras.title}</h2>
          ) : null}
          {extras.subtitle ? (
            <p className="extras-subtitle">{extras.subtitle}</p>
          ) : null}
        </div>

        <div className="extras-grid">
          {cards.map((card, index) => {
            const Icon = CARD_ICONS[index];
            const isSvgIcon = Icon === FullSizeSuvIcon;

            return (
              <div key={index} className="extra-card">
                {isSvgIcon ? (
                  <Icon className="extra-icon svg-icon" />
                ) : (
                  <Icon className="extra-icon" />
                )}
                {card.title ? <h3>{card.title}</h3> : null}
                {card.description ? <p>{card.description}</p> : null}
              </div>
            );
          })}
        </div>

        {extras.positioning_line ? (
          <div className="extras-positioning">
            <MdShield className="positioning-icon" />
            <span>{extras.positioning_line}</span>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default Mhero1Extras;
